<template>
  <v-card>
    <v-card-title class="i-dialog-header-div">
      <span class="g-heading-m g-bold">{{ dialogData.heading }}</span>
    </v-card-title>

    <v-card-text class="text-center py-6">
      <v-alert
        v-if="hasProductFGChanges(product)"
        dense
        outlined
        text
        border="left"
        class="mb-0 i-alert"
        elevation="1"
        icon="mdi-alert"
        type="info"
      >
        <span>Warning: Family Group related changes</span>
      </v-alert>
      <div class="ml-2">
        <v-checkbox
          style="display: inline-block"
          v-model="deletionConfirmation"
          :label="dialogData.tickboxMessage"
        >
        </v-checkbox>
      </div>
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions class="i-dialog-actions-div justify-center">
      <v-btn rounded text class="i-btn-text-black" @click="handleCancel">
        <strong>Cancel</strong>
      </v-btn>

      <v-btn
        rounded
        class="i-btn-block-secondary"
        :disabled="!deletionConfirmation"
        :loading="deleting"
        @click="handleDelete"
      >
        <strong>{{ dialogData.buttonMessage }}</strong>
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
const DELETE_EDIT_OF_ARCHIVE_PRODUCT = {
  heading: 'Product Archiving',
  buttonMessage: 'Archive',
  tickboxMessage:
    'This product has been ARCHIVED before -  Return product to ARCHIVE'
}

const DELETE_EDIT_WITH_FAMILY_GROUP_CHANGES = {
  heading: 'Upcoming Edit Deletion',
  buttonMessage: 'Delete',
  tickboxMessage:
    'Upcoming Edit deletion will APPLY to ALL products in Family Group'
}

const DELETE_EDIT = {
  heading: 'Upcoming Edit Deletion',
  buttonMessage: 'Delete',
  tickboxMessage: 'Delete this upcoming Edit of a current LIVE product'
}

const DELETE_EDIT_OF_NEW_PRODUCT = {
  heading: 'Product Deletion',
  buttonMessage: 'Delete',
  tickboxMessage: 'This product has not been LIVE - Delete before it goes LIVE'
}

const DELETE_NEW_PRODUCT = {
  heading: 'Product Deletion',
  buttonMessage: 'Delete',
  tickboxMessage: 'This product has NOT been LIVE - Delete DRAFT product'
}

const DELETE_DEFAULT = {
  heading: 'Product Deletion',
  buttonMessage: 'Delete',
  tickboxMessage: 'This product will be deleted'
}

export default {
  props: {
    deleting: {
      type: Boolean,
      default: false
    },
    product: {
      type: Object,
      default: () => {}
    }
  },

  data: () => ({
    deletionConfirmation: false
  }),

  computed: {
    dialogData() {
      if (this.isEditOfLiveProductWithFGChanges(this.product))
        return DELETE_EDIT_WITH_FAMILY_GROUP_CHANGES
      else if (this.isEditOfLiveProduct(this.product)) return DELETE_EDIT
      else if (this.isEditOfArchivedProduct(this.product))
        return DELETE_EDIT_OF_ARCHIVE_PRODUCT
      else if (this.isEditOfNewProduct(this.product))
        return DELETE_EDIT_OF_NEW_PRODUCT
      else if (this.isDraftOfUnarchivedProduct(this.product))
        return DELETE_EDIT_OF_ARCHIVE_PRODUCT
      else if (this.isNewDraftProduct(this.product)) return DELETE_NEW_PRODUCT
      else return DELETE_DEFAULT
    }
  },

  methods: {
    handleCancel() {
      this.$emit('cancel')
    },

    handleDelete() {
      this.$emit('confirm', this.product)
    },

    hasProductFGChanges(product) {
      return !!product?.hasPriceOrRrpImpactingChanges && !!product?.familyGroup
    },

    isEditOfLiveProductWithFGChanges(product) {
      return (
        this.isEditOfLiveProduct(product) && this.hasProductFGChanges(product)
      )
    },

    isEditOfLiveProduct(product) {
      return (
        (product.status === 'LIVE_FUTURE' ||
          product.status === 'AWAITING_APPROVAL') &&
        product?.live
      )
    },

    isEditOfArchivedProduct(product) {
      return (
        (product.status === 'LIVE_FUTURE' ||
          product.status === 'AWAITING_APPROVAL') &&
        product?.wasOrIsLive &&
        !product?.live
      )
    },

    isEditOfNewProduct(product) {
      return (
        (product.status === 'LIVE_FUTURE' ||
          product.status === 'AWAITING_APPROVAL') &&
        !product?.wasOrIsLive
      )
    },

    isDraftOfUnarchivedProduct(product) {
      return (
        product.status === 'DRAFT' && product?.wasOrIsLive && !product?.live
      )
    },

    isNewDraftProduct(product) {
      return product.status === 'DRAFT' && !product?.wasOrIsLive
    }
  }
}
</script>
